import React, { useState, useEffect } from 'react';
import { isLive } from '../../Utils/Utilities';
import useIsMobile from '../../Hooks/useIsMobile';

const themeColors = ['#bf5700', '#0b5d1e', '#0d1f2d'];

const renderColoredTitle = (title, idx) => {
  const color = themeColors[idx % themeColors.length];
  if (typeof title === 'string' && title.startsWith('Smart ')) {
    const rest = title.slice(6);
    return (
      <>
        Smart <br /><span style={{ color }}>{rest}</span>
      </>
    );
  }
  return title;
};

const FeaturesCompact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = document.querySelector('.features-compact-section');
    if (section) {
      observer.observe(section);
    }

    return () => observer.disconnect();
  }, []);

  /*
  const features = [
    {
      title: 'Integrate Inquiries in a Single Platform',
      subtitle: 'Integrate with IndiaMART, JustDial, TradeIndia, Meta forms, etc.',
    image: isLive() ? '/Web/assets/Images/Landing/Features/1_import.png' : '/assets/Images/Landing/Features/1_import.png',
    },
    {
      title: 'Maintain Stage-wise Sales Funnel',
      subtitle: '',
    image: isLive() ? '/Web/assets/Images/Landing/Features/2_inquiry.png' : '/assets/Images/Landing/Features/2_inquiry.png',
    },
    {
      title: 'Monitor Team Efforts',
      subtitle: '',
    image: isLive() ? '/Web/assets/Images/Landing/Features/3_team.png' : '/assets/Images/Landing/Features/3_team.png',
    },
    {
      title: 'Manage Tasks On-the-Go',
      subtitle: '',
    image: isLive() ? '/Web/assets/Images/Landing/Features/4_tasks.png' : '/assets/Images/Landing/Features/4_tasks.png',
    },
    {
      title: 'Analyze to Improve',
      subtitle: '',
    image: isLive() ? '/Web/assets/Images/Landing/Features/5_report.png' : '/assets/Images/Landing/Features/5_report.png',
    }
  ];
  */

  const features = [
    {
      title: 'Smart Management',
      subtitle: 'Finish Tasks Faster, Delegate Reliably to Team, Improve Meetings & Decisions',
      image: isLive() ? '/Web/assets/Images/Onboarding/Tasks.png' : '/assets/Images/Onboarding/Tasks.png',
    },
    {
      title: 'Smart Sales Growth',
      subtitle: 'Track Lead Pipeline, Monitor Team Performance, Increase Repeat Orders',
      image: isLive() ? '/Web/assets/Images/Onboarding/Inquiries.png' : '/assets/Images/Onboarding/Inquiries.png',
    },
    {
      title: 'Smart Networking',
      subtitle: 'Promote on B2B Community, Get Business Opportunities, Find Better Suppliers (coming soon)',
      image: isLive() ? '/Web/assets/Images/Onboarding/Network.png' : '/assets/Images/Onboarding/Network.png',
    }
  ];

  const handleImageClick = (imageUrl) => {
    window.open(imageUrl, '_blank');
  };

  return (
    <section className="features-compact-section py-12 pb-20 md:py-20 px-4 md:px-6 bg-white">
      <div className="md:max-w-[70%] max-w-full mx-auto">

        {/* Section Header */}
        {/* <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-sahi-dark-blue mb-4 mt-8">
            Everything You Need in <span className="text-sahi-green">One Platform</span>
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
            Streamline your sales process with our comprehensive features
          </p>
        </div> */}

        {/* Features Grid */}

        {isMobile ? (
          // Mobile Layout
          <div className={`space-y-10 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
            {features.map((feature, idx) => (
              <div key={idx}>
                <div
                  className="group"
                  style={{
                    transitionDelay: isVisible ? `${idx * 100}ms` : '0ms',
                  }}
                >
                  {/* Mobile Content */}
                  <div className="mb-8">
                    <div className="flex justify-center gap-2">
                      <div>
                        <h3 className="text-3xl font-bold text-sahi-dark-blue text-center leading-tight mb-6 mt-6">
                          {renderColoredTitle(feature.title, idx)}
                        </h3>
                        {feature.subtitle && (
                          <p className="text-gray-600 text-base max-w-2xl mx-auto text-center leading-relaxed">
                            {feature.subtitle}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Mobile Image Container */}
                  <div className="relative overflow-hidden rounded-lg">
                    <img
                      src={feature.image}
                      alt={feature.title}
                      className="w-full h-auto object-cover"
                      onClick={() => handleImageClick(feature.image)}
                    />
                  </div>
                </div>

                {/* Divider */}
                {/* {idx < features.length - 1 && (
                  <div className="h-px mt-16 bg-gradient-to-r from-transparent via-gray-400 to-transparent"></div>
                )} */}
              </div>
            ))}
          </div>
        ) : (
          // Desktop Layout
          <div className={`grid grid-cols-2 gap-8 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
            {features.map((feature, idx) => (
              <div
                key={idx}
                className="group"
                style={{
                  transitionDelay: isVisible ? `${idx * 100}ms` : '0ms',
                }}
              >
                {/* Card Container */}
                <div className="bg-gradient-to-br from-white to-gray-50 border-2 border-sahi-green/20 rounded-2xl p-4 shadow-lg shadow-black/5 hover:shadow-xl hover:border-sahi-green/40 transition-all duration-300 h-full">

                  {/* Image Container */}
                  <div className="relative mb-4 bg-white border border-gray-200 rounded-lg p-2 overflow-hidden">
                    <div className="absolute -inset-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-br from-sahi-green/10 to-green-600/10 -z-10 blur-sm"></div>

                    <div className="relative overflow-hidden rounded-md">
                      <img
                        src={feature.image}
                        alt={feature.title}
                        className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="space-y-2">
                    <div className="flex items-start gap-2">
                      <div className="flex-shrink-0 mt-1">
                        <svg className="w-5 h-5 text-sahi-green" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div>

                        <h3 className="text-xl font-medium text-sahi-dark-blue leading-tight">
                          {renderColoredTitle(feature.title, idx)}
                        </h3>
                        {feature.subtitle && (
                          <p className="text-sm text-gray-600 mt-1">
                            {feature.subtitle}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Bottom Accent */}
                  <div className="mt-4 justify-start flex">
                    <div className="h-1 w-12 bg-gradient-to-r from-sahi-green to-green-600 rounded-full group-hover:w-20 transition-all duration-300"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

      </div>
    </section>
  );
};

export default FeaturesCompact;